import React, { useState, useEffect } from 'react';
import { Grid, Table } from '@mui/material'; // Using Material-UI components
import { FaTrash, FaEye } from 'react-icons/fa';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Constants } from '../../endPoints';
import { jwtDecode } from 'jwt-decode'; // Corrected import
import Breadcumb from '../../Layouts/Breadcumb';
import DashboardNav from './DashboardNav';
import MySwal from 'sweetalert2';

const Listwishlist = () => {
  const [products, setProducts] = useState([]);
  const [productImages, setProductImages] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [feedbackType, setFeedbackType] = useState('');

  useEffect(() => {
    const fetchWishlist = async () => {
      const accessToken = localStorage.getItem('authToken');
      if (!accessToken) {
        console.error('No access token found');
        return;
      }

      const decodedToken = jwtDecode(accessToken);
      const idUser = decodedToken.id; // idUser is extracted from the decoded token

      try {
        const wishlistResponse = await axios.get(`${Constants.getUserWishlist}/${idUser}`);

        if (wishlistResponse.data.status === 1 && wishlistResponse.data.list) {
          const wishlist = wishlistResponse.data.list;

          const productRequests = wishlist.map(item => {
            return axios.get(`${Constants.getProductById}/${item.idProduct}`);
          });

          try {
            const productResponses = await Promise.all(productRequests);

            const productsData = productResponses
              .filter(response => response.data.success === 1) // Filter only successful responses
              .map(response => response.data.data);

            setProducts(productsData); // Set the products data only if the response is successful
          } catch (error) {
            console.error("Error fetching product details:", error);
          }
        }
      } catch (error) {
        console.error('Error fetching wishlist or product data:', error);
      } finally {
        setIsLoading(false); // Make sure loading state is false
      }
    };

    fetchWishlist();
  }, []);

  useEffect(() => {
    const fetchProductImages = async () => {
      const images = {};
      try {
        if (products.length === 0) return;

        await Promise.all(
          products.map(async (product) => {
            try {
              const response = await axios.get(`${Constants.getProductImagesById}/${product.id}`);
              if (response.data.status === 1 && response.data.data.length > 0) {
                images[product.id] = response.data.data[0]; // First image
              } else {
                images[product.id] = { image: 'product_default.png' }; // Fallback
              }
            } catch (error) {
              console.error(`Error fetching image for product ${product.id}:`, error);
              images[product.id] = { image: 'product_default.png' }; // Fallback on error
            }
          })
        );

        setProductImages(images);
      } catch (error) {
        console.error('Error fetching product images:', error);
      }
    };

    fetchProductImages();
  }, [products]);

  const handleDeleteProduct = async (productId) => {
    try {
      // Call API to delete from wishlist
      const accessToken = localStorage.getItem('authToken');
      if (!accessToken) {
        console.error('No access token found');
        return;
      }

      const decodedToken = jwtDecode(accessToken);
      const idUser = decodedToken.id; // Get user ID from token

      // Make sure the endpoint is correct, embedding the productId into the URL
      const response = await axios.delete(`${Constants.deleteFromWishlist}/${productId}`, {
        data: { idUser }, // Send the idUser as the body (request payload)
      });

      if (response.data.status === 1) {
        // Successfully deleted, remove from the products list
        setProducts(prevProducts => prevProducts.filter(product => product.id !== productId));
        // setFeedbackMessage(`Product ${productId} successfully deleted from wishlist.`);
        // setFeedbackType('success'); // Set feedback type to 'success'
        MySwal.fire({
          icon: 'success',
          title: 'Wishlist Deleted!',
          text: 'The Wishlist has been successfully deleted.',
        });
      } else {
        setFeedbackMessage('Failed to delete product from wishlist.');
        setFeedbackType('error'); // Set feedback type to 'error'
      }
    } catch (error) {
      console.error('Error deleting product from wishlist:', error);
      setFeedbackMessage('An error occurred while deleting the product.');
      setFeedbackType('error'); // Set feedback type to 'error'
    }
  };

  return (
    <>
      <Breadcumb pagetitle="Wishlist" />
      <section className='dashboardsec'>
        <div className='container mx-auto px-4'>
          <Grid container spacing={5}>
            <Grid item lg={3} md={12} sm={12} xs={12}>
              <DashboardNav />
            </Grid>
            <Grid item lg={9} md={12} sm={12} xs={12}>
              <div className="main-content">
                <div className="page-content">
                  <h2 className="text-3xl font-bold headningfont mb-3">My Wishlist</h2>
                </div>
                {feedbackMessage && (
                  <div
                    style={{
                      marginTop: "16px",       // mt-4
                      padding: "16px",         // p-4
                      textAlign: "center",     // text-center
                      borderRadius: "6px",     // rounded-md
                      backgroundColor: feedbackType === 'success' ? "#D1FAE5" : "#FEE2E2", // green-100 / red-100
                      color: feedbackType === 'success' ? "#047857" : "#B91C1C",           // green-700 / red-700
                    }}
                  >
                    {feedbackMessage}
                  </div>
                )}

                <Grid item xs={12} className="tableparents">
                  <Table className='w-full tabledeisgn text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 table-auto border'>
                    <thead className='text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400'>
                      <tr>
                        <th className='px-4 py-3'>Product ID</th>
                        <th className='px-4 py-3'>Country</th>
                        <th className='px-4 py-3'>Main Selection</th>
                        <th className='px-4 py-3'>Category</th>
                        <th className='px-4 py-3'>Shop For</th>
                        <th className='px-4 py-3'>Image</th>
                        <th className='px-4 py-3'>Status</th>
                        <th className='px-4 py-3'>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        <tr>
                          <td colSpan="8" className="text-center py-4">Loading...</td>
                        </tr>
                      ) : (
                        products.map((product) => {
                          console.log("Rendering product:", product); // Log the product object before rendering
                          return (
                            <tr key={product.id} className='odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700'>
                              <td className="px-4 py-4">{product.id}</td>
                              <td className="px-4 py-4">{product.countryName}</td>
                              <td className="px-4 py-4">{product.selectionName}</td>
                              <td className="px-4 py-4">{product.categoryName}</td>
                              <td className="px-4 py-4">{product.shopForName}</td>
                              <td className="px-4 py-4">
                                {productImages[product.id] ? (
                                  <img
                                    src={`${Constants.imageBaseURL}${productImages[product.id].image}`} // Display the first image only
                                    alt={`Product ${product.id}`}
                                    style={{ width: '50px', height: '50px', objectFit: 'cover', marginRight: '5px' }}
                                  />
                                ) : (
                                  <span>No Image</span> // Display this if no image is available
                                )}
                              </td>
                              <td className="px-4 py-4">{product.status}</td>
                              <td className="px-4 py-4 text-center">
                                <div className='flex gap-3 d-flex editview items-center'>
                                  <Link to={`/details/${product.id}`} className="text-blue-500 hover:text-blue-700 eyeicn transition p-2 rounded-full hover:bg-blue-100"><FaEye /></Link>
                                  <button type='button' className="text-red-500 hover:text-red-700 deleteicn transition p-2 rounded-full hover:bg-red-100" onClick={() => handleDeleteProduct(product.id)}><FaTrash /></button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </Table>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </div>
      </section>
    </>
  );
};

export default Listwishlist;
